import {showNotification} from 'platform/components';

import {
  useCreateInsuranceDraftMutation,
  useOfferBusinessCaseInsuranceMutation,
} from '@dms/api/sales';
import {handleApiError} from '@dms/shared';

import {isInsuranceVehicleV2} from '../utils/isInsuranceVehicleV2';
import {InsuranceData} from './useInsuranceData';

export function useInsuranceComparison(
  businessCaseId: string,
  {insuranceVehicle, insurerNumber, vehicleId}: InsuranceData
) {
  const [createInsuranceDraft, {isLoading}] = useCreateInsuranceDraftMutation();
  const [setInsuranceToOffered] = useOfferBusinessCaseInsuranceMutation();

  const compareOffers = async () => {
    if (!insurerNumber || !vehicleId || !isInsuranceVehicleV2(insuranceVehicle)) {
      return showNotification.error();
    }

    await createInsuranceDraft({
      businessCaseId,
    })
      .unwrap()
      .then(async (data) => {
        data?.url && window.open(data.url, '_blank');
        if (businessCaseId) {
          await setInsuranceToOffered({businessCaseId});
        }
      })
      .catch(handleApiError);
  };

  return {compareOffers, isComparisonLoading: isLoading};
}
